import { useCallback, useContext } from "react";
import { NavigatorContext } from "../../../../context";

export const useTopNavbarBanner = ({ onClick }) => {
  const { navigateTo } = useContext(NavigatorContext);

  const ctaClick = useCallback(() => {
    onClick();
    navigateTo({ route: "/services/detailing" });
  }, [onClick, navigateTo]);
  return {
    ctaClick,
  };
};
